import { render, staticRenderFns } from "./UnsupportViewRedirect.vue?vue&type=template&id=e7b1bdb4&scoped=true&"
import script from "./UnsupportViewRedirect.vue?vue&type=script&lang=ts&"
export * from "./UnsupportViewRedirect.vue?vue&type=script&lang=ts&"
import style0 from "./UnsupportViewRedirect.vue?vue&type=style&index=0&id=e7b1bdb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b1bdb4",
  null
  
)

export default component.exports